import React from "react";
import { Form, Input } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import parsePhoneNumberFromString from "libphonenumber-js";
import PhoneInput from "../../../../../shared/PhoneInput";

// Everything the sign up form asks for: who you are, how to reach you and how
// to sign in. Nothing else.
//
// The company profile that used to be here — the organization's name and type,
// the country, state, city, address line and ZIP — is gone. None of it is
// needed to open an account, and the address it asked for was the billing
// address by another name: that is collected once, on the card form, by Stripe
// (see pages/auth/payment/StripeForm). What the register endpoint still insists
// on is filled in from these five fields; see registrationDefaults.js.

const AccountDetails = ({ shouldDisable }) => {
   return (
      <div className="left-block">
         <h1 className="heading-create-account">Create an account</h1>
         <p className="paragraph-create-account-subtitle">
            Just your details to get started — you can add your organization's information later.
         </p>
         <Form.Item
            label="Full name*"
            name="fullname"
            rules={[
               {
                  required: true,
                  message: "Please input your Full name!"
               }
            ]}
         >
            <Input disabled={shouldDisable} placeholder="Enter your full name..." />
         </Form.Item>
         <Form.Item
            label="Email*"
            name="email"
            rules={[
               {
                  required: true,
                  message: "Please enter an email"
               },
               {
                  pattern: /^[a-zA-Z][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Please enter a valid email address"
               }
            ]}
         >
            <Input disabled={shouldDisable} placeholder="Type your email address..." />
         </Form.Item>
         <Form.Item
            label="Password*"
            name="password"
            rules={[
               {
                  required: true,
                  message: "Please input your password!"
               },
               {
                  pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,}$/,
                  message:
                     "Password must include uppercase, lowercase, number, and special character and minimum length of password - 8"
               }
            ]}
         >
            <Input.Password
               disabled={shouldDisable}
               placeholder="Set up your account's password..."
               suffix={<EyeOutlined />}
            />
         </Form.Item>
         <Form.Item
            label="Confirm Password*"
            name="confirm"
            dependencies={["password"]}
            rules={[
               {
                  required: true,
                  message: "Please confirm your password!"
               },
               ({ getFieldValue }) => ({
                  validator(_, value) {
                     if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                     }
                     return Promise.reject(
                        new Error(
                           "Oops! It seems like there's a mismatch between the passwords you entered."
                        )
                     );
                  }
               })
            ]}
         >
            <Input.Password disabled={shouldDisable} placeholder="Confirm your password..." />
         </Form.Item>
         <Form.Item
            label="Phone Number*"
            name="phone"
            rules={[
               {
                  required: true,
                  message: "This field is required"
               },
               () => ({
                  validator(_, value) {
                     if (!value) {
                        return Promise.resolve();
                     }
                     const phoneNumber = parsePhoneNumberFromString(value, "us");
                     if (!phoneNumber || !phoneNumber.isValid()) {
                        return Promise.reject(new Error("Invalid phone number"));
                     }
                     return Promise.resolve();
                  }
               })
            ]}
         >
            <PhoneInput
               disabled={shouldDisable}
               onChange={(val) => {
                  return val;
               }}
            />
         </Form.Item>
      </div>
   );
};

export default AccountDetails;
